<div id="tiles" class="container-fluid ml-0 mt-3 px-0">
  <div class="row">
    <ng-container *ngFor="let tile of tiles">
      <app-tile
        class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3"
        [tile]="tile"
        [parentRoute]="parentRoute"
      ></app-tile>
    </ng-container>
  </div>
</div>
